import { render, staticRenderFns } from "./PayTarBar.vue?vue&type=template&id=08ae6284&scoped=true"
import script from "./PayTarBar.vue?vue&type=script&lang=js"
export * from "./PayTarBar.vue?vue&type=script&lang=js"
import style0 from "./PayTarBar.vue?vue&type=style&index=0&id=08ae6284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ae6284",
  null
  
)

export default component.exports